export default __webpack_public_path__ + "static/user-centric-optimized-ad51185f3c36feda9003b5e23902060e.jpg";